export default "__VITE_ASSET__DU$InFZA__"